import { getTeamIdFromURL } from '@/_helpers';
import { fetchCallsAction, updateCallDataAction } from '@/_redux/actions/ActionCallCenter';
import Pagination from '@/components/Admin/Pagination';
import { ContainerStyles } from '@/components/Admin/Settings';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import React, { useState, useEffect } from 'react';
import { InputGroup, Spinner, FormLabel } from 'react-bootstrap';

import { connect } from 'react-redux';
import Select from 'react-select';
import CallAccordion from './CallAccordion';

export const ContactSelect = ({ value, onChange, contacts }) => (
    <Select
        value={value ? { value: value, label: contacts.find((l) => (l.id || l._id) === value)?.name || '' } : null}
        onChange={(option) => onChange(option ? option.value : '')}
        options={[{ label: 'All', value: '' }].concat(
            contacts.map((contact) => ({
                label: contact.name,
                value: contact.id || contact._id,
            }))
        )}
        placeholder="Contact: All"
        isClearable
    />
);

export const StatusSelect = ({ value, onChange }) => (
    <Select
        value={value ? { value: value, label: value } : null}
        onChange={(option) => onChange(option ? option.value : '')}
        options={[
            { label: 'All', value: '' },
            { label: 'Queued', value: 'queued' },
            { label: 'Ringing', value: 'ringing' },
            { label: 'In Progress', value: 'in_progress' },
            { label: 'Completed', value: 'completed' },
            { label: 'Failed', value: 'failed' },
            { label: 'No Answer', value: 'no_answer' },
            { label: 'Busy', value: 'busy' },
        ]}
        placeholder="Status: All"
        isClearable
    />
);

export const LabelSelect = ({ value, onChange, labels }) => (
    <Select
        value={
            value
                ? {
                      value: value,
                      label: (
                          <div className="d-flex align-items-center">
                              <div
                                  style={{
                                      width: '12px',
                                      height: '12px',
                                      backgroundColor:
                                          labels.find((l) => (l.id || l._id) === value)?.colorHex || '#ccc',
                                      borderRadius: '50%',
                                      marginRight: '8px',
                                  }}
                              ></div>
                              {labels.find((l) => (l.id || l._id) === value)?.name || 'Unknown'}
                          </div>
                      ),
                  }
                : null
        }
        onChange={(option) => onChange(option ? option.value : '')}
        options={[{ label: 'All', value: '' }].concat(
            labels.map((label) => ({
                label: (
                    <div className="d-flex align-items-center">
                        <div
                            style={{
                                width: '12px',
                                height: '12px',
                                backgroundColor: label.colorHex,
                                borderRadius: '50%',
                                marginRight: '8px',
                            }}
                        ></div>
                        {label.name}
                    </div>
                ),
                value: label.id || label._id,
            }))
        )}
        placeholder="Label: All"
        isClearable
    />
);

export const PresetSelect = ({ value, onChange, presets = [] }) => (
    <Select
        value={
            value
                ? {
                      value: value,
                      label: (
                          <div className="d-flex align-items-center">
                              {presets.find((l) => (l.id || l._id) === value)?.title || 'Unknown'}
                          </div>
                      ),
                  }
                : null
        }
        onChange={(option) => onChange(option ? option.value : '')}
        options={[].concat(
            presets.map((preset) => ({
                label: <div className="d-flex align-items-center">{preset.title}</div>,
                value: preset.id || preset._id,
            }))
        )}
        placeholder="Preset: All"
        isClearable
    />
);

const Component = ({
    calls = [],
    contacts = [],
    labels = [],
    presets = [],
    loading = false,
    onUpdateCall,
    onBargeIn,
    onListenIn,
    fetchCallsAction,
    updateCallDataAction,
    totalCalls,
}) => {
    const teamId = getTeamIdFromURL();
    const [filteredCalls, setFilteredCalls] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [allCalls, setAllCalls] = useState([]);
    const [filters, setFilters] = useState({ page: 1 });
    const handleStatusFilterChange = (status) => {
        setFilters({
            ...filters,
            status,
        });
    };
    const handleLabelFilterChange = (label) => {
        setFilters({
            ...filters,
            label,
        });
    };
    const handlePresetFilterChange = (preset) => {
        setFilters({
            ...filters,
            preset,
        });
    };
    const handleContactFilterChange = (contact) => {
        setFilters({
            ...filters,
            contact,
        });
    };
    const onPageChanged = (data) => {
        if (data.currentPage < 1) {
            data.currentPage = 1;
        }
        setFilters({
            ...filters,
            page: data.currentPage || 1,
        });
    };

    useEffect(() => {
        const fetchCalls = async () => {
            try {
                setFilteredCalls(calls);
                setAllCalls(calls);
            } catch (err) {
                console.error(err);
            }
        };
        fetchCalls();
    }, [calls]);

    useEffect(() => {
        fetchCallsAction(teamId, filters);
    }, [teamId, filters]);

    useEffect(() => {
        const list = Array.isArray(allCalls) ? allCalls.filter(Boolean) : [];
        if (!searchText) return setFilteredCalls(allCalls);

        const lower = searchText.toLowerCase();
        setFilteredCalls(
            list.filter((c) => {
                const contact = c?.contactData || {};
                const full = contact?.name?.toLowerCase() || '';
                return full.includes(lower) || (contact.phone || '').includes(lower);
            })
        );
    }, [searchText, allCalls]);

    return (
        <div className="called-tab">
            <div className="d-flex gap-2 mb-3 align-items-center flex-row" style={{ width: '900px', gap: '10px' }}>
                {/* <InputGroup>
                    <input
                        className="input"
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                        placeholder="Search calls/contacts..."
                        style={{
                            width: '250px',
                            border: '1px solid #ccc',
                            borderRadius: 6,
                            padding: '6px 10px',
                        }}
                    />
                </InputGroup> */}
                <div>
                    <InputGroup
                        className="mb-3 flex-column"
                        style={{
                            width: '250px',
                        }}
                    >
                        <FormLabel className="mr-2">Contact:</FormLabel>
                        <ContactSelect
                            value={filters.contact}
                            onChange={handleContactFilterChange}
                            contacts={contacts}
                        />
                    </InputGroup>
                </div>
                <div>
                    <InputGroup className="mb-3 flex-column">
                        <FormLabel className="mr-2">Status:</FormLabel>
                        <StatusSelect value={filters.status} onChange={handleStatusFilterChange} />
                    </InputGroup>
                </div>
                <div>
                    <InputGroup className="mb-3 flex-column">
                        <FormLabel className="mr-2">Preset:</FormLabel>
                        <PresetSelect value={filters.preset} onChange={handlePresetFilterChange} presets={presets} />
                    </InputGroup>
                </div>
                {/* <div>
                    <InputGroup className="mb-3 flex-column">
                        <FormLabel className="mr-2">Call Transcript:</FormLabel>
                        <input
                            className="input"
                            onChange={(e) => setSearchText(e.target.value)}
                            value={searchText}
                            placeholder="Search transcript..."
                            style={{
                                width: '250px',
                                border: '1px solid #ccc',
                                borderRadius: 6,
                                padding: '6px 10px',
                            }}
                        />
                    </InputGroup>
                </div> */}

                {/* <div>
                    <InputGroup className="mb-3 flex-column">
                        <FormLabel className="mr-2">Label:</FormLabel>
                        <LabelSelect value={filters.label} onChange={handleLabelFilterChange} labels={labels} />
                    </InputGroup>
                </div> */}
            </div>

            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" />
                    <p className="mt-2">Loading calls...</p>
                </div>
            ) : (filteredCalls || []).length === 0 ? (
                <div className="text-center py-5">
                    <p>No calls found.</p>
                </div>
            ) : (
                (filteredCalls || []).map((call, index) => (
                    <CallAccordion
                        labels={labels}
                        key={call.id}
                        call={{ ...call, contactData: call?.contactData || {} }}
                        updateCallDataAction={updateCallDataAction}
                        currentPage={filters?.page}
                        index={index}
                    />
                ))
            )}
            <ContainerStyles className="py-4 d-flex align-items-center">
                {totalCalls ? (
                    <Pagination
                        totalRecords={totalCalls}
                        pageLimit={10}
                        pageNeighbours={1}
                        pageNo={filters.page}
                        onPageChanged={onPageChanged}
                    />
                ) : null}
            </ContainerStyles>
        </div>
    );
};

const mapStateToProps = (state) => ({
    contacts: state.callCenter.contacts || [],
    calls: state.callCenter.calls || [],
    totalCalls: state.callCenter.totalCalls,
    labels: state.callCenter.labels || [],
    presets: state.callCenter.presets || [],
});
const mapDispatchToProps = {
    fetchCallsAction,
    updateCallDataAction,
};

const CalledTab = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(CalledTab);
